require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-new-chapter-at-yarrabend.json") })
        }
      }, "path---news-new-chapter-at-yarrabend");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-new-chapter-at-yarrabend!./.cache/json/news-new-chapter-at-yarrabend.json
// module id = 832
// module chunks = 231608221292675